import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaEnterpriseService {

  private siteKey = environment.recaptchaSiteKey;
  private readonly scriptId = 'recaptcha-enterprise-script';

  load(): void {
    if (!document.getElementById(this.scriptId)) {
      const script = document.createElement('script');
      script.id = this.scriptId;
      script.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${this.siteKey}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    this.setBadgeVisibility('visible');
  }

  unload(): void {
    this.setBadgeVisibility('hidden');
  }

  private setBadgeVisibility(visibility: 'visible' | 'hidden'): void {
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement | null;
    if (badge) { badge.style.visibility = visibility; }
  }

  executeScore(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
        reject(new Error('reCAPTCHA Enterprise not loaded'));
        return;
      }
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(this.siteKey, { action });
          resolve(token);
        } catch (err) {
          reject(err);
        }
      });
    });
  }
}
